import { useState } from 'react'
import { colors, glyphs } from '../../Styles'
import { PrimaryPopover } from '..'
import { PopoverPosition } from '../../Definitions'

interface UserGroupPopover_Props {
  userGroupName: string
  userGroupNote?: string
  glyphColor?: colors
}
/**
 * UserGroupPopover
 * @param selectedUser
 * @returns
 */
export default function UserGroupPopover({userGroupName, userGroupNote, glyphColor}:UserGroupPopover_Props) {
  const [, setIsOpen] = useState(false)

  return (
    <PrimaryPopover
      content={
        <div onClick={() => setIsOpen(true)} style={{ width: "fit-content", height: "fit-content", margin: "-5px 0px", cursor: "pointer" }}>
          <glyphs.Note fillColor={glyphColor}/>
        </div>
      } 
      overrides={{
        popoverPosition: PopoverPosition.bottom
      }}
      popoverHeader={userGroupName} 
      popoverContent={
        <div style={{display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "center",  color: colors.whitePrimary}}>
          {userGroupNote?.split("\n").map((line, index) => (
            <div key={index}>{line}</div>
          ))}
        </div>
      } 
    />
  )
}